import { FC } from "react";
import { AlignItems, ContainerBaseProps, JustifyContent, Wrap } from "../types";

const ContainerBase: FC<ContainerBaseProps> = ({
  flexDirection,
  background = "transparent",
  justifyContent = JustifyContent.Start,
  alignItems = AlignItems.Center,
  flexWrap = Wrap.NoWrap,
  children = <></>,
  style = {},
  gap = 0,
  className = "",
  props,
  containerRef,
}) => {
  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection,
        background,
        alignItems,
        justifyContent,
        flexWrap,
        gap,
        ...style,
      }}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};

export default ContainerBase;
